<template>
  <div class="record">
    <div class="record_banner"></div>
    <div class="record_chang">
      <div class="record_side">
        <!-- 方剂部分 -->
        <div class="rside_ks">
          <p class="rside_title">
            <img src="../../assets/an/prescription_icon@2x.png" alt />方剂
          </p>
          <div class="rside_ks_li" v-for="(item,index) in fangji_name1" :key="index">
            <p class="rside_ks_li_title1">{{item}}</p>
            <p class="rside_ks_li_title2">
              <span
                v-for="(kitem,kindex) in fangji_name2[index]"
                :key="kindex"
                :title="kitem.name"
                @click="goanlist(kitem.name,kitem.ksname,1)"
              >{{kitem.name}}</span>
            </p>
            <!--  v-if="index == 0" style="display:block;" -->
            <div class="rside_ks_allin">
              <div class="rside_ks_allin_box">
                <div
                  class="rside_ks_allin_li"
                  v-for="(aitem,aindex) in fangji_allin[index]"
                  :key="aindex"
                >
                  <p class="allin_title">
                    <span>{{aitem.name}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="fangji_all_show[index][aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p class="allin_content_level">
                        <span
                          v-for="(ditem,dindex) in aitem.child_categories"
                          :key="dindex"
                          :class="fangji_list_tab[index][aindex][dindex]==1?'allin_content_level_active':''"
                          @click="istcheck(index,aindex,dindex,1)"
                        >{{ditem.name}}</span>
                      </p>
                      <div
                        class="allin_content_level2"
                        v-for="(bitem,bindex) in aitem.child_categories"
                        :key="bindex"
                        v-show="fangji_list_tab[index][aindex][bindex] == 1"
                      >
                        <p
                          class="allin_content_p"
                          v-for="(citem,cindex) in bitem.fangs"
                          :key="cindex"
                          @click="goanlist(citem.fang_name,bitem.name,1)"
                        >{{citem.fang_name}}</p>
                      </div>
                    </div>
                    <div class="dashed"></div>
                    <div
                      v-show="fangji_all_show[index][aindex] != 3"
                      class="allin_content_hide"
                      :class="fangji_all_show[index][aindex] == 2?'allin_content_open':''"
                      @click="check_open(index,aindex,1)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rside_ks_li">
            <p class="rside_ks_li_title3">更多方剂</p>
            <!-- style="display:block;" -->
            <div class="rside_ks_allin" >
              <div class="rside_ks_allin_box">
                <div class="rside_ks_allin_li" v-for="(aitem,aindex) in fangjiArr" :key="aindex">
                  <p class="allin_title">
                    <span>{{aitem.name}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="fangji_allin_show[aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p class="allin_content_level">
                        <span
                          v-for="(bitem,bindex) in aitem.child_categories"
                          :class="fangji_alllist_tab[aindex][bindex]==1?'allin_content_level_active':''"
                          @click="istcheck(0,aindex,bindex,2)"
                          :key="bindex"
                        >{{bitem.name}}</span>
                      </p>
                      <div
                        class="allin_content_level2"
                        v-for="(bitem,bindex) in aitem.child_categories"
                        :key="bindex"
                        v-show="fangji_alllist_tab[aindex][bindex] == 1"
                      >
                        <p
                          class="allin_content_p"
                          v-for="(citem,cindex) in bitem.fangs"
                          :key="cindex"
                          @click="goanlist(citem.fang_name,bitem.name,1)"
                        >{{citem.fang_name}}</p>
                      </div>
                    </div>
                    <div class="dashed"></div>
                    <div
                      v-show="fangji_allin_show[aindex] != 3"
                      class="allin_content_hide"
                      :class="fangji_allin_show[aindex] == 2?'allin_content_open':''"
                      @click="check_open(0,aindex,4)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 推荐经验方 -->
        <div class="rside_ks rside_yj">
          <p class="rside_title">
            <img src="../../assets/an/doctor_icon2@2x.png" alt />名家经验方
          </p>
          <div class="rside_ks_li" v-for="(item,index) in doctor_all_name" :key="index">
            <p class="rside_ks_li_title3">
              <span v-for="(nitem,nindex) in item" :key="nindex">{{nitem}}</span>
            </p>
            <div class="rside_ks_allin">
              <div class="rside_ks_allin_box">
                <div
                  class="rside_ks_allin_li"
                  v-for="(aitem,aindex) in doctor_all[index]"
                  :key="aindex"
                >
                  <p class="allin_title">
                    <span>{{aitem.doctor_name}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="doctor_all_show[index][aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p
                        class="allin_content_p"
                        v-for="(bitem,bindex) in aitem.fangs"
                        :key="bindex"
                        @click="goanlist(bitem.fang_name,aitem.name,2)"
                      >{{bitem.fang_name}}</p>
                    </div>
                    <div class="dashed"></div>
                    <div
                      class="allin_content_hide"
                      v-show="doctor_all_show[index][aindex] != 3"
                      :class="doctor_all_show[index][aindex] == 2?'allin_content_open':''"
                      @click="check_open(index,aindex,2)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rside_ks_li">
            <p class="rside_ks_li_title3">
              <span>更多经验方</span>
            </p>
            <div class="rside_ks_allin">
              <div class="rside_ks_allin_box">
                <div class="rside_ks_allin_li" v-for="(aitem,aindex) in doctorArr" :key="aindex">
                  <p class="allin_title">
                    <span>{{aitem.doctor_name}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="doctor_allin_show[aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p
                        class="allin_content_p"
                        v-for="(bitem,bindex) in aitem.fangs"
                        :key="bindex"
                        @click="goanlist(bitem.fang_name,aitem.name,2)"
                      >{{bitem.fang_name}}</p>
                    </div>
                    <div class="dashed"></div>
                    <div
                      class="allin_content_hide"
                      v-show="doctor_allin_show[aindex] != 3"
                      :class="doctor_allin_show[aindex] == 2?'allin_content_open':''"
                      @click="check_open(aindex,aindex,3)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="record_cj">
        <p class="record_title">
          <span>经验方</span>找一找是否有你需要
        </p>
        <ul class="rcj_ul">
          <li
            class="rcj_li"
            v-for="(item,index) in changArr"
            :key="index"
            @click="goanlist_yj(item.fang_name,3)"
          >
            <p>{{item.fang_name}}</p>
            <p>{{item.doctor_name}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      changArr: [],
      // 方剂arr
      fangjiArr: [],
      // 全部方剂分类
      fangji_allin: [],
      // 方剂名 名/名/名
      fangji_name1: [],
      // 方剂-汤剂 名 名 名
      fangji_name2: [],
      // 方剂详情显示
      fangji_all_show: [],
      fangji_allin_show: [],
      // 方剂切换tab
      fangji_list_tab: [],
      fangji_alllist_tab: [],
      // 名家arr
      doctorArr: [],
      // 经验方前三
      doctor_all: [],
      // 经验方前三的医家名
      doctor_all_name: [],
      // 经验方前3 显示
      doctor_all_show: [],
      // 经验方——更多 显示
      doctor_allin_show: []
    };
  },
  created() {
    this.get_chang();
    this.getside_doctor();
    this.getside_fang();
  },
  methods: {
    // 列表展开切换
    check_open(index, bindex, num) {
      if (num == 1) {
        if (this.fangji_all_show[index][bindex] == 1) {
          this.$set(this.fangji_all_show[index], [bindex], 2);
        } else {
          this.$set(this.fangji_all_show[index], [bindex], 1);
        }
      } else if (num == 2) {
        if (this.doctor_all_show[index][bindex] == 1) {
          this.$set(this.doctor_all_show[index], [bindex], 2);
        } else {
          this.$set(this.doctor_all_show[index], [bindex], 1);
        }
      } else if (num == 3) {
        if (this.doctor_allin_show[index] == 1) {
          this.$set(this.doctor_allin_show, [bindex], 2);
        } else {
          this.$set(this.doctor_allin_show, [bindex], 1);
        }
      } else if (num == 4) {
        // console.log(bindex)
        if (this.fangji_allin_show[bindex] == 1) {
          this.$set(this.fangji_allin_show, [bindex], 2);
        } else {
          this.$set(this.fangji_allin_show, [bindex], 1);
        }
      }
    },
    istcheck(index, aindex, bindex, num) {
      if (num == 1) {
        for (let i = 0; i < this.fangji_list_tab[index][aindex].length; i++) {
          if (i == bindex) {
            this.$set(this.fangji_list_tab[index][aindex], i, 1);
          } else {
            this.$set(this.fangji_list_tab[index][aindex], i, 2);
          }
        }
        // console.log(this.fangji_allin[index][aindex].child_categories[bindex].fangs.length)
        if (
          this.fangji_allin[index][aindex].child_categories[bindex].fangs
            .length < 16
        ) {
          this.$set(this.fangji_all_show[index], [aindex], 3);
        } else {
          this.$set(this.fangji_all_show[index], [aindex], 2);
        }
      } else if (num == 2) {
        for (let i = 0; i < this.fangji_alllist_tab[aindex].length; i++) {
          if (i == bindex) {
            this.$set(this.fangji_alllist_tab[aindex], i, 1);
          } else {
            this.$set(this.fangji_alllist_tab[aindex], i, 2);
          }
        }
        // console.log(this.fangjiArr[aindex].child_categories[bindex].fangs.length)
        if (this.fangjiArr[aindex].child_categories[bindex].fangs.length < 16) {
          this.$set(this.fangji_allin_show, [aindex], 3);
        } else {
          this.$set(this.fangji_allin_show, [aindex], 2);
        }
      }
      // console.log(this.fangji_list_tab)
      // console.log(this.fangji_alllist_tab)
    },
    get_chang() {
      let that = this;
      this.$axios.get("zk_fang/common").then(function(res) {
        if (res.data.status_code == 200) {
          // console.log(res);
          that.changArr = res.data.data;
        }
      });
    },
    getside_fang() {
      let that = this;
      this.$axios.get("zk_fang/categories").then(function(res) {
        if (res.data.status_code == 200) {
          // console.log(res.data.data);
          that.fangjiArr = res.data.data;
          that.fangji_allin = that.listTemp(that.fangjiArr);
          that.fangji_name1 = that.ktitleTemp(that.fangjiArr);
          that.fangji_name2 = that.btitleTemp(that.fangjiArr);
        }
      });
    },
    getside_doctor() {
      let that = this;
      this.$axios.get("zk_fang/doctors").then(function(res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.doctorArr = res.data.data;
          that.allinyj_showadd(that.doctorArr);
          that.dorctor_listTemp(that.doctorArr);
        }
      });
    },
    goanlist(iname, ksname, num) {
      this.$router.push({
        path: "/fangList",
        query: {
          name: iname,
          ks: ksname,
          t: num
        }
      });
    },
    goanlist_yj(iname, num) {
      this.$router.push({
        path: "/fangList",
        query: {
          name: iname,
          t: num
        }
      });
    },
    // 总列表分割
    listTemp(tempArr) {
      let index = 0;
      let count = 3;
      let arrTemp = [];
      let isarrTemp = [];
      let listarrTemp = [];
      let isfangjiArr = [];
      let isfangjiArr_tab = [];
      // console.log(tempArr);
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        let isArr = tempArr[i];
        // let isshow = 1;
        if (arrTemp.length <= index) {
          arrTemp.push([]);
          isarrTemp.push([]);
          listarrTemp.push([]);
        }
        // isshow = 2;
        let iarr = [];
        let jarr = [];
        for (let j = 0; j < isArr.child_categories.length; j++) {
          if (j == 0) {
            iarr.push(1);
            jarr.push(1);
          } else {
            iarr.push(2);
            jarr.push(2);
          }
        }
        // console.log(isArr)
        listarrTemp[index].push(iarr);
        arrTemp[index].push(tempArr[i]);
        // console.log(isArr.child_categories)
        if (isArr.child_categories[0].fangs.length > 16) {
          isarrTemp[index].push(2);
          isfangjiArr.push(2);
        } else {
          isarrTemp[index].push(3);
          isfangjiArr.push(3);
        }
        isfangjiArr_tab.push(jarr);
      }
      // console.log(isarrTemp);
      // console.log(isfangjiArr);
      this.fangji_all_show = isarrTemp;
      this.fangji_list_tab = listarrTemp;
      this.fangji_allin_show = isfangjiArr;
      this.fangji_alllist_tab = isfangjiArr_tab;
      // console.log(arrTemp);
      return arrTemp;
    },
    allinyj_showadd(tempArr) {
      let arr = [];
      for (let i = 0; i < tempArr.length; i++) {
        // arr.push(2);
        if (tempArr[i].fangs.length > 16) {
          arr.push(2);
        } else {
          arr.push(3);
        }
      }
      this.doctor_allin_show = arr;
      // console.log(isshowArr)
    },
    // 医家数据处理
    dorctor_listTemp(tempArr) {
      let index = 0;
      let count = 3;
      let titleTemp = [];
      let titleArr = [];
      let doctorArr = [];
      let isdoctorArr = [];
      // console.log(tempArr)
      for (let i = 0; i < 9; i++) {
        index = parseInt(i / count);
        if (titleTemp.length <= index) {
          titleTemp.push([]);
          doctorArr.push([]);
          isdoctorArr.push([]);
        }
        titleTemp[index].push(tempArr[i].doctor_name);
        doctorArr[index].push(tempArr[i]);
        if (tempArr[i].fangs.length > 8) {
          isdoctorArr[index].push(2);
        } else {
          isdoctorArr[index].push(3);
        }
      }
      this.doctor_all = doctorArr;
      this.doctor_all_show = isdoctorArr;
      // console.log(doctorArr);
      // console.log(isdoctorArr);
      for (let i = 0; i < 3; i++) {
        let title = "";
        for (let j = 0; j < titleTemp[i].length; j++) {
          let tarr = titleTemp[i];
          if (tarr.length == 1) {
            title = tarr[0];
          } else {
            if (j == tarr.length - 1) {
              title += tarr[j];
            } else {
              title += tarr[j] + "/";
            }
          }
        }
        // console.log(title)
        titleArr.push(title);
      }
      this.doctor_all_name = titleArr;
      // console.log(titleArr);
      // return titleArr;
    },
    // 科室名分割
    ktitleTemp(tempArr) {
      let index = 0;
      let count = 3;
      let titleTemp = [];
      let titleArr = [];
      let fangjiArr = tempArr;
      // console.log(tempArr)
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        if (titleTemp.length <= index) {
          titleTemp.push([]);
        }
        titleTemp[index].push(fangjiArr[i].name);
      }
      //   this.department_titleArr = titleTemp
      //   console.log(titleTemp);
      for (let i = 0; i < titleTemp.length; i++) {
        let title = "";
        if (i > 3) break;
        for (let j = 0; j < titleTemp[i].length; j++) {
          let tarr = titleTemp[i];
          if (tarr.length == 1) {
            title = tarr[0];
          } else {
            if (j == tarr.length - 1) {
              title += tarr[j];
            } else {
              title += tarr[j] + "/";
            }
          }
        }
        // console.log(title)
        titleArr.push(title);
      }
      // console.log(titleArr)
      return titleArr;
    },
    // 科室下病名分割
    btitleTemp(tempArr) {
      let index = 0;
      let count = 3;
      let titleTemp = [];
      let fangjiArr = tempArr;
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        if (titleTemp.length <= index) {
          titleTemp.push([]);
        }

        if (fangjiArr[i].child_categories[0].fangs.length > 0) {
          // console.log(222)
          titleTemp[index].push({
            name: fangjiArr[i].child_categories[0].fangs[0].fang_name,
            ksname: fangjiArr[i].name
          });
        } else {
          // console.log(111)
          // console.log(i)
          titleTemp[index].push({
            name: fangjiArr[i].child_categories[0].name,
            ksname: fangjiArr[i].name
          });
        }
        // console.log(fangjiArr[i].child_categories[0].name)
      }
      // console.log(fangjiArr[0].name)
      // .child_categories[0].fangs[0].name
      //   this.department_titleArr = titleTemp
      // console.log(titleTemp);
      return titleTemp;
    }
  }
};
</script>
<style scoped lang="scss"  type="text/css">
.record {
  background: #fff;
  width: 100%;
  .record_search {
    left: calc(50% - 595px) !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .record_banner {
    width: 100%;
    height: 430px;
    background: url(../../assets/an/fang_banner.jpg) no-repeat center center;
    background-size: cover;
  }
  .record_chang {
    width: 1200px;
    height: 326px;
    margin: 0 auto;
    display: flex;
    // border: 1px solid red;
    position: relative;
    .record_side {
      width: 250px;
      height: 724px;
      position: absolute;
      top: -430px;
      left: 0;
      // border: 1px solid green;
      background:#364A7F;
        box-shadow:0px 0px 23px 3px rgba(32,49,95,0.45);
      .rside_ks {
        width: 100%;
        .rside_title {
          color: #fff;
          font-size: 20px;
          flex-wrap: 800;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          vertical-align: middle;
          margin-top: 20px;
          margin-bottom: 10px;
          text-indent: 7px;
          line-height: 20px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
            vertical-align: bottom;
          }
        }
        .rside_ks_li {
          width: 100%;
          height: 55px;
          margin-bottom: 14px;
          .rside_ks_li_title1,
          .rside_ks_li_title2,
          .rside_ks_li_title2 span,
          .rside_ks_li_title3 span,
          .rside_ks_li_title3 {
            //   width: 100%;
            color: #fff !important;
          }
          .rside_ks_li_title1 {
            text-indent: 35px;
            line-height: 30px;
            letter-spacing: 1px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
          }
          .rside_ks_li_title2 {
            cursor: pointer;
            width: 211px;
            line-height: 25px;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: PingFangSC-Light;
            font-weight: 100;
            padding-left: 35px;
            span {
              text-align: left;
              margin-right: 10px;
              max-width: 4em;
              display: inline-block;
              overflow: hidden;
            }
            span:hover {
              color: #364A7F;
            }
          }
          .rside_ks_li_title3 {
            font-size: 16px;
            line-height: 55px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            // line-height: 49px;
            padding-left: 35px;
            // span {
            //   margin-right: 10px;
            //   cursor: pointer;
            //   &:hover {
            //     color: #5b1c00;
            //   }
            // }
          }
          .rside_ks_allin {
            position: absolute;
            top: 0;
            left: 250px;
            z-index: 9;
            width: 950px;
            height: 724px;
            display: none;
            background: #FFF1E8;
            box-sizing: border-box;
            padding: 35px 30px 30px 0px;
            .rside_ks_allin_box {
              width: 100%;
              height: 100%;
              overflow-y: scroll;
            }
            .rside_ks_allin_li {
              width: 100%;
              display: flex;
              position: relative;
              .allin_title {
                width: 118px;
                text-align: right;
                margin-right: 5px;
                line-height: 16px;
                margin-top: 4px;
                font-family: PingFangSC-Medium;
                span {
                  text-align-last: justify;
                }
                ins {
                  display: inline-block;
                  width: 16px;
                  height: 16px;
                  vertical-align: bottom;
                  background: url("../../assets/an/right_icon@2x.png")
                    no-repeat center center;
                  background-size: cover;
                }
              }
              .allin_content {
                width: 776px;
                .allin_content_div {
                  margin-bottom: 68px;
                  // min-height: 74px;
                  width: 100%;
                  position: relative;
                  font-size: 14px;
                }
                .allin_content_level {
                  height: 24px;
                  width: 100%;
                  margin-bottom: 16px;
                  span {
                    display: inline-block;
                    padding: 3px 7px;
                    margin-right: 4px;
                    cursor: pointer;
                  }
                  .allin_content_level_active {
                    background: #B48758;
                    color: #fff;
                  }
                }
                .allin_content_p {
                  font-size: 14px;
                  padding: 5px 12px 0px;
                  margin-bottom: 13px;
                  display: inline-block;
                  position: relative;
                  cursor: pointer;
                  color: #333;
                  // border-right: 1px solid #7f655a;
                  line-height: 16px;
                  font-family: PingFangSC-Light;
                  &:hover {
                    color: #B48758;
                  }
                  &::after {
                    content: "";
                    width: 0px;
                    height: 16px;
                    display: inline-block;
                    border-right: 1px solid #8E8E8E;
                    position: absolute;
                    right: 0;
                    top: 5px;
                  }
                }
                .allin_content_p:last-of-type {
                  &::after {
                    border-right: 0px solid red;
                  }
                }
              }
              .dashed {
                width: 762px;
                position: absolute;
                right: 18px;
                bottom: 58px;
                height: 1px;
                background-image: linear-gradient(
                  to right,
                  #8E8E8E 0%,
                  #8E8E8E 60%,
                  transparent 40%
                );
                background-size: 8px 1px;
                background-repeat: repeat-x;
                margin-top: 14px;
                opacity: 0.6;
              }
              .allin_content_hiddden {
                max-height: 106px;
                overflow: hidden;
                margin-bottom: 60px;
                // .allin_content_hide {
                //   background: url("../../assets/record/down_icon@2x.png")
                //     no-repeat center center;
                // }
              }
            }
            .allin_content_hide {
              width: 20px;
              height: 20px;
              position: absolute;
              right: 406px;
              bottom: 0px;
              margin: 0 auto;
              // border:1px solid red;
              margin-top: 4px;
              margin-bottom: 30px;
              cursor: pointer;
              background: url("../../assets/an/up_icon@2x.png") no-repeat
                center center;
              background-size: cover;
            }
            .allin_content_open {
              background: url("../../assets/an/down_icon@2x.png") no-repeat
                center center;
              background-size: cover;
            }
          }
          &:hover {
            background: #D7AD81;
            .rside_ks_allin {
              display: block;
            }
          }
        }
      }
      .rside_yj.rside_ks {
        margin-top: 42px;
        .rside_ks_li {
          margin-bottom: 0;
          .rside_ks_li_title3 {
            height: 55px;
            span {
              &:hover {
                color: #fff;
              }
            }
          }
          .allin_content_hiddden {
            max-height: 68px !important;
          }
        }
      }
    }
    .record_cj {
      width: 915px;
      height: 326px;
      margin-left: 40px;
      position: absolute;
      right: 0;
      .record_title {
        color: #999;
        margin-top: 28px;
        font-family: PingFangSC-Regular;
        span {
          color: #333;
          font-size: #333;
          font-family: PingFangSC-Medium;
          margin-right: 12px;
        }
      }
      .rcj_ul {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .rcj_li {
          width: 163px;
          height: 100px;
          background: url(../../assets/an/disease_background@2x.png)
            no-repeat center center;
          background-size: 100% 100%;
          text-align: center;
          color: #723a14;
          margin-top: 20px;
          cursor: pointer;
          box-sizing: border-box;
          padding: 26px 24px;
          p {
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>